import { useMutation } from '@apollo/client';
import { useCustomSnackbar } from '@procureai/ui-mui';
import { DocumentNode } from 'graphql';

import { mapSavingFormDataToInput } from '../../SavingsWidget.util';
import { SavingFormData } from '../SavingForm/SavingForm.schema';
import { getReadableErrorMessage } from '~/util/error/getReadableErrorMessage';

import { CREATE_SAVING_MUTATION } from './CreateSavingDialog.mutation.gql.ts';

interface CreateSavingBackendResult {
  saving: boolean;
  save: (data: SavingFormData) => Promise<{ success: boolean }>;
}

export const useCreateSavingBackend = (): CreateSavingBackendResult => {
  const { enqueueErrorSnackbar } = useCustomSnackbar();

  const [createSaving, { loading: saving }] = useMutation(CREATE_SAVING_MUTATION as DocumentNode, {
    refetchQueries: ['SavingsList'],
  });

  return {
    saving,
    save: async (data) => {
      try {
        const result = await createSaving({
          variables: {
            input: mapSavingFormDataToInput(data),
          },
        });

        if (result.errors?.length) {
          enqueueErrorSnackbar(result.errors.map((error) => error.message).join('\n'));
          return { success: false };
        }

        if (result.data?.createSaving?.id) {
          return { success: true };
        }
      } catch (error) {
        enqueueErrorSnackbar(getReadableErrorMessage(error));
      }

      return { success: false };
    },
  };
};
